import {
  CREATE_DIAGNOSIS,
  DIAGNOSIS_All_TAG,
  DIAGNOSIS_SEARCH_TAG,
  GET_DIAGNOSIS_PATIENT_MEDICATION,
  GET_MAIN_COMPLAIN_FROM_MASTERVALUE,
  UPDATE_DIAGNOSIS,
} from "../../../constants/asyncActionsType";
import createAsyncThunkForSlice from "../../../utils/utils";
import {
  creatediagnosis,
  getDiagnosisPatientMedication,
  getDiagnosisTags,
  getMasterValueMainComplaint,
  getdiagnosisSearchTags,
  updatediagnosis,
} from "./doctorDiagnosisCrud";

export const createDiagnosis = createAsyncThunkForSlice(
  CREATE_DIAGNOSIS,
  creatediagnosis,
  {
    isToast: true,
  }
);

export const updateDiagnosis = createAsyncThunkForSlice(
  UPDATE_DIAGNOSIS,
  updatediagnosis,
  {
    isToast: true,
  }
);

export const getDiagnosisSearchTags = createAsyncThunkForSlice(
  DIAGNOSIS_SEARCH_TAG,
  getdiagnosisSearchTags
);

export const getDiagnosisAllTags = createAsyncThunkForSlice(
  DIAGNOSIS_All_TAG,
  getDiagnosisTags
);

export const getDiagnosisPatientMedications = createAsyncThunkForSlice(
  GET_DIAGNOSIS_PATIENT_MEDICATION,
  getDiagnosisPatientMedication
);

export const getMainComplaintFromMasterValue = createAsyncThunkForSlice(
  GET_MAIN_COMPLAIN_FROM_MASTERVALUE,
  getMasterValueMainComplaint
);
